var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policyPage"},[_c('Top'),_c('div',{staticClass:"container pretendard"},[_c('router-view',{staticClass:"policyBox"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }